import React, { useState, useContext, useEffect } from 'react';
import { Modal, Row, Col, Button, Spinner, Alert } from "react-bootstrap";
import IProgramFailure from '../../../../../../domain/core/failures/program/programFailure';
import { IProgramsListContext, ProgramsListContext } from '../../../../../../application/context/Programs/ProgramsList/ProgramsListContext';
import { IProgram } from '../../../../../../domain/core/entities/programEntity';

interface IProps {
    show: boolean;
    onHide: Function;
    animation?: boolean;
    program: IProgram;
    handleDeleteProgram: Function;
}

export default function DeleteProgramModal({ show, onHide, animation = false, program, handleDeleteProgram }: IProps) {
    const { state, actions, dispatch } = useContext<IProgramsListContext>(ProgramsListContext);
    const { deleteProgram } = actions;
    const { loading, sucessful, error } = state.deleteProgramState;

    const [hasSucessful, setHasSucessful] = useState<boolean | null>(null);
    const [hasError, setHasError] = useState<IProgramFailure | null>(null);

    const onDeleteProgram = () => {
        setHasError(null);
        deleteProgram(program.programId)(dispatch);
    }

    useEffect(() => {
        if (hasSucessful) {
            handleDeleteProgram();
            setHasSucessful(null);
            onHide();
        }
    }, [handleDeleteProgram, onHide, hasSucessful])

    useEffect(() => {
        if (sucessful) setHasSucessful(sucessful);
    }, [sucessful])

    useEffect(() => {
        if (error) setHasError(error);
    }, [error])

    return (
        <Modal 
        show={show} 
        hide={loading ? () => {} : onHide} 
        animation={animation}
        size="lg"
        centered
        >
            <Modal.Body>
                <Row className="text-center">
                    <Col lg={12} className="mb-4">
                        <svg className="icon icon-danger" xmlns="http://www.w3.org/2000/svg" height="70px" viewBox="0 0 24 24" width="70px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>
                    </Col>

                    <Col lg={12} className="mb-3">
                        <h6 className="text-danger">Eliminar programa</h6>
                    </Col>

                    {hasError && (
                        <Col lg={12} className="mb-3">
                           <Alert variant="danger" className="text-left">
                               <p className="text-white">Algo ha salido mal al intentar eliminar el programa. Intentalo nuevamente.</p>
                           </Alert>
                        </Col>
                    )}

                    <Col lg={12} className="mb-5">
                        <span>Al eliminar el programa, este no podra seguir siendo visto ni utilizado en la plataforma de Priority Pet.</span>
                    </Col>

                    <Col lg={6}>
                        <Button disabled={loading} onClick={() => onHide()} variant="" className="py-2 w-100">
                            No deseo eliminar
                        </Button>
                    </Col>

                    <Col lg={6} className="mb-4">
                        <Button onClick={() => onDeleteProgram()} disabled={loading} variant="danger" className="py-2 w-100">
                            {loading ? (
                                <Spinner className="spinner-border-white" animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                            ) : (
                                'Eliminar'
                            )}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>  
    );
}
